import React from "react";
import InfoIcon from '@mui/icons-material/Info';
import { AccentInfo, Detail } from "../../../StyledComponents";
import {
  TimelineCallout,
  TimelineChangeList,
  TimelineChangeRow,
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineSection,
  TimelineSectionTitle,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const formatFinalizedValue = (detail, value) => {
  if (!value) {
    return <AccentInfo style={{fontWeight: '400'}}>-empty-</AccentInfo>
  }

  if (detail.field.includes('Rate') || detail.field.includes('%')) {
    return `${value}%`
  }

  if (
    detail.field.includes('Parcel')
    || detail.field.includes('Term')
    || detail.field.includes('Owner')
    || detail.field.includes('Date')
    || detail.field.includes('Unit')
    || detail.field.includes('Street')
    || detail.field.includes('City')
    || detail.field.includes('Postal')
    || detail.field.includes('State')
  ) {
    return value
  }

  return `$${value.toLocaleString("en-US", {maximumFractionDigits: 2, minimumFractionDigits: 0})}`
}

const Finalized = ({milestone}) => (
  <TimelineContent>
    <TimelineTitleRow>
      <TimelineTitle>{milestone.milestone}</TimelineTitle>
      {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
    </TimelineTitleRow>
    <TimelineMetaList>
      <TimelineMetaRow>
        <span className="timeline-meta-label">initiated by:</span>
        <span className="timeline-meta-value">{milestone.contributor}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">date:</span>
        <span className="timeline-meta-value">{milestone.date}</span>
      </TimelineMetaRow>
    </TimelineMetaList>
    {milestone.details && milestone.details.length > 0 &&
      <TimelineSection>
        <TimelineSectionTitle>Financial information provided</TimelineSectionTitle>
        <TimelineChangeList>
          {milestone.details.map((detail) => (
            <TimelineChangeRow key={detail.field}>
              <span className="timeline-change-label">{detail.label}:</span>
              <span className="timeline-change-value">
                {formatFinalizedValue(detail, detail.old)}
                <span> to </span>
                {formatFinalizedValue(detail, detail.new)}
              </span>
            </TimelineChangeRow>
          ))}
        </TimelineChangeList>
      </TimelineSection>
    }
    {milestone.ownershipUpdates && milestone.ownershipUpdates.length > 0 &&
      <TimelineSection>
        <TimelineSectionTitle>Updates to Ownership</TimelineSectionTitle>
        <TimelineChangeList>
          {milestone.ownershipUpdates.map((update) => (
            <TimelineChangeRow key={update.field}>
              <span className="timeline-change-label">{update.label}:</span>
              <span className="timeline-change-value">
                {update.old || <AccentInfo style={{fontWeight: '400'}}>-empty-</AccentInfo>}
                <span> to </span>
                {update.new || <AccentInfo style={{fontWeight: '400'}}>-empty-</AccentInfo>}
              </span>
            </TimelineChangeRow>
          ))}
        </TimelineChangeList>
      </TimelineSection>
    }
    {milestone.newProfits &&
      <TimelineSection>
        <TimelineSectionTitle>Finalized outcome</TimelineSectionTitle>
        <TimelineChangeList>
          <TimelineChangeRow>
            <span className="timeline-change-label">finalized profit:</span>
            <span className="timeline-change-value">
              {Math.sign(milestone.newProfits.profitNumber.new) !== -1 && !milestone.newProfits.profitPercent.negative ?
                <Detail className="timelineItem green">${milestone.newProfits.profitNumber.new.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}</Detail>
              : milestone.newProfits.profitPercent.negative ?
                <Detail className="timelineItem red">-${(milestone.newProfits.profitNumber.new).toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}</Detail>
              :
                <Detail className="timelineItem red">-${(milestone.newProfits.profitNumber.new*-1).toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}</Detail>
              }
            </span>
          </TimelineChangeRow>
          <TimelineChangeRow>
            <span className="timeline-change-label">profit difference:</span>
            <span className="timeline-change-value">
              {!milestone.newProfits.profitPercent.negative ?
                <Detail className="timelineItem green">{milestone.newProfits.profitPercent.new.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}%</Detail>
              :
                <Detail className="timelineItem red">{(milestone.newProfits.profitPercent.new*-1).toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}%</Detail>
              }
            </span>
          </TimelineChangeRow>
        </TimelineChangeList>
      </TimelineSection>
    }
    {milestone.awaitingUpdate &&
      <TimelineCallout>
        <span className="timeline-callout-icon"><InfoIcon /></span>
        <span className="timeline-callout-copy">
          Currently awaiting the expected changes to be reflected in public records and verified.
        </span>
      </TimelineCallout>
    }
  </TimelineContent>
)

export default Finalized
